import React from 'react';
import ReactDOM from 'react-dom';
import "./polyfills";
import { BrowserRouter } from "react-router-dom";
import './index.css';
import './i18n';
import App from './App';
import "./assets/base.scss";
import reportWebVitals from './reportWebVitals';
// import configureStore from "./config/configureStore";
import { Provider } from "react-redux";
import store from './store';

ReactDOM.render(
  <Provider store={store}>
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
